<template>
  <div class="my-table editMenuPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editMenu.txt10')}}</span>
        <span>{{$t('editMenu.txt11')}} / {{$t('editMenu.txt12')}} / {{this.$route.query.id?$t('editMenu.txt13'):$t('editMenu.txt14')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn ml20" @click="onBack">{{$t('editMenu.txt15')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{this.$route.query.id?$t('editMenu.txt13'):$t('editMenu.txt14')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('editMenu.txt16')}}</div>
          <div class="searchBtn" @click="confirmRole">{{$t('editMenu.txt17')}}</div>
        </div>
      </div>
      <div class="editForm">
        <el-form :model="editMenuForm" :rules="editMenuRules" ref="editMenuForm" class="demo-ruleForm">  
         <el-row  :gutter="20">
          <el-col :span="8">
            <el-form-item :label="$t('editMenu.txt18')" prop="menuName">
              <el-input v-model="editMenuForm.menuName" :placeholder="$t('editMenu.txt19')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('editMenu.txt21')" prop="menuUrl">
              <el-input :placeholder="$t('editMenu.txt20')" v-model="editMenuForm.menuUrl"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('editMenu.txt22')" prop="parentId">
              <el-cascader style="width: 100%" ref="cascader" @change="changeParentId" v-model="editMenuForm.parentId" :options="menuTree" 
              :props="{ checkStrictly: true, value: 'id', label: 'name' }" clearable></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('editMenu.txt23')" prop="menuType">
              <el-select v-model="editMenuForm.menuType" :placeholder="$t('editMenu.txt24')">
                <el-option v-for="item in menuTypes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item :label="$t('editMenu.txt25')" prop="menuIcon">
              <div class="flexStartBtn">
                <div class="menuIconBox">
                  <el-upload class="avatar-uploader"
                  :action="uploadAction" :show-file-list="false" :headers="uploadHeaders"
                  :on-exceed="handleAvatarExceed" :on-success="handleAvatarSuccess">
                  <img v-if="editMenuForm.menuIcon" :src="serverUrl + '/'+editMenuForm.menuIcon" class="avatar">
                  <img v-else class="el-icon-plus avatar-uploader-icon"
                  src="@/assets/picture/icon/addpicture_icon.png" width="22" />
                </el-upload>
              </div>
              <div class="ml20">
                <p class="tips">{{$t('editMenu.txt26')}}</p>
                <p class="tips">{{$t('editMenu.txt27')}}</p>
                <div v-if="editMenuForm.menuIcon">
                  <el-button type="text" @click="editMenuForm.menuIcon = ''">{{$t('editMenu.txt28')}}</el-button>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</el-card>


</div>
</template>

<script>
  import {apiUrl, serverUrl} from '@/utils/request';
  import axios from "axios";
  import qs from 'qs';
  export default {
    data() {
      return {
        editMenuForm: {
          menuIcon: '', // 菜单图标url
          menuName: '', // 菜单名称
          menuType: '', // 菜单类型,1:请求转发(本系统),2：重定向(比如重定向到第三方网站)
          menuUrl: '', // 菜单url
          parentId: '', // 菜单父id
        },
        menuTree: [],
        editMenuRules: {
          menuName: [
          { required: true, message: this.$t('editMenu.txt29'), trigger: 'blur' },
          ],
          menuUrl: [
          { required: true, message: this.$t('editMenu.txt30'), trigger: 'blur' },
          ],
          menuType: [
          { required: true, message: this.$t('editMenu.txt31'), trigger: 'change' },
          ],
        },
        menuTypes:[
        { label: this.$t('editMenu.txt32'), value: '1' },
        { label: this.$t('editMenu.txt33'), value: '2' },
        { label: this.$t('editMenu.txt34'), value: '3' },
        ],
        uploadHeaders: {
          Authorization: localStorage.token
        },
        uploadAction: apiUrl + '/menu/upload',
        serverUrl
      };
    },
    created() {
      this.getMenuTree();
      if(this.$route.query.id){
        this.getMenuInfo(this.$route.query.id);
      }
    },
    methods: {
      onBack(){
        this.$router.go(-1);
      },
      async getMenuTree() {
        this.loading = true
        const { data: res } = await this.$http.post("/menu/getMenuTree");
        this.loading = false;
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.dataList = JSON.parse(JSON.stringify(res.result))
        res.result.unshift({
          name: this.$t('editMenu.txt35'),
          id: '0',
        })
        each(res.result)
        function each(list) {
          list.forEach(item =>{
            if(!item.parentId) {
              item.parentId = '0'
            }
            if(item.children && item.children.length == 0) {
              delete(item.children)
            }
            else {
              item.children && each(item.children)
            }
          })
        }
        this.menuTree = res.result;
      },
      changeParentId(){
        // if(this.$route.query.id){
          let parentId = '';
          let len = this.editMenuForm.parentId.length;
          parentId = this.editMenuForm.parentId[len-1];
          this.editMenuForm.parentId = parentId;
        // }
      },
      // 菜单详细
      async getMenuInfo(id) {
        let data = {
          menuId:id
        }
        const { data: res } = await this.$http.post("/menu/getMenuInfo?" + qs.stringify(data) );
        this.loading = false;
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.editMenuForm = res.result;
        if(!this.editMenuForm.parentId) {
          this.editMenuForm.parentId = '0'
        }
      },
      async confirmRole() {
        // let data = JSON.parse(JSON.stringify(this.editMenuForm))
        // delete data.children
        const { data: res } = await this.$http.post("/menu/add?" + qs.stringify(this.editMenuForm) );
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.$message.success(this.$t('editMenu.txt36'));
        this.onBack();
      },
      handleAvatarSuccess(res, file) {
        if (res.result) {
          this.editMenuForm.menuIcon = res.result;
        }
        else {
          return this.$message.error(res.message);
        }
      },
      handleAvatarExceed(files, fileList) {
         this.$message.warning(this.$t('editTask.txt18')+files.length);
      },
    }
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .editMenuPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .w350{
      width: 350px;
    }
    .searchUserBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      /deep/ .el-input__inner{
        border:1px solid #C0C0C0;
        border-right:none;
      }
      /deep/ .el-input-group__append{
        border:1px solid #C0C0C0;
        border-left:none;
        padding:0;
        background: #fff;
      }
      /deep/ .el-input-group__append button.el-button{
        padding:0;
        width: auto;
        margin-right: 1.1rem;
      }
    }
    .tips{      
      font-size: 1.4rem;
      font-weight: 400;
      color: #222;
      padding: 0;
      margin-bottom: 0;
    }
    /deep/  .el-date-table td.today span{
      color: #fff;
      background: #1B3B7C;
      border-radius: 100%;
    }
    /deep/ .el-date-table td.end-date span,/deep/ .el-date-table td.start-date span{
      background: #1B3B7C !important;
    }

    /deep/ .el-dialog .el-dialog__body .el-select .el-input__inner,
    .el-dialog .el-dialog__body .el-input__inner,
    .el-dialog .el-dialog__body .el-input {
      border-radius: 8px;
    }

    /deep/ .el-upload__input {
      display: none;
    }
    .menuIconBox{
      width: 10rem;
      height: 10rem;
    }
    .avatar-uploader{
      width: 10rem;
      height: 10rem;
      background: #F4F4F4;
      border: none;
      border-radius: 1.8rem;
    }
    .avatar-uploader .el-upload {
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 10rem;
      height: 10rem;
      background: #F4F4F4;
      border: none;
      border-radius: 1.8rem;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #C2CAD8;
      line-height: 56px;
      text-align: center;
      width: 2.8rem;
      height: 2.8rem;
      margin: 0 auto;
      display: block;
      margin-top: 3.4rem;
      margin-left: 3.4rem;
    }

    .new-avatar-uploader-icon {
      font-size: 28px;
      color: #007eff;
      line-height: 56px;
      text-align: center;
      width: 200px;
      height: 200px;
      background: #ebf5ff;
      border-radius: 9px;
      padding-top: 65px;
      margin: 0 auto;
      display: block;
    }

    .avatar {
      width: 10rem;
      height: 10rem;
      background: #F4F4F4;
      border: none;
      border-radius: 1.8rem;
    }
  }

</style>
